<template>
    <section class="c-o-section-instructions">
        <h2 class="c-o-section-instructions__title">{{ headline }}</h2>
        <div class="c-o-section-instructions__content">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="c-o-section-instructions__block"
            >
                <div
                    class="c-o-section-instructions__badge"
                    :class="
                        `c-o-section-instructions__badge--index-${index + 1}`
                    "
                >
                    <icon
                        class="c-o-section-instructions__icon"
                        :icon="getIconName(index + 1)"
                    ></icon>
                </div>
                <h3 class="c-o-section-instructions__block-title">
                    {{ item.title }}
                </h3>
                <p class="c-o-section-instructions__text">{{ item.content }}</p>
            </div>
        </div>
    </section>
</template>

<script>
import Icon from "../../atoms/AtomIcon.vue";
import filters from "../../../../filters/index.js";

export default {
    filters: filters,
    props: ["content", "data"],
    data() {
        return {
            headline: this.content.headline,
            items: this.content.instructions_list
        };
    },
    components: {
        Icon
    },
    methods: {
        getIconName: function(index) {
            switch (index) {
                case 1:
                    return "check_circle";
                case 2:
                    return "thumb_up";
                case 3:
                    return "star";
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionInstructions.vue